import { AxiosAdapter } from '../../_config/adapters/axios/axios.adapter';
import { Http } from '../../_config/adapters/axios/axios.protocols';
import { ENVIROMENT } from '../../v2-config/constants/enviroments.constant';

export class Service {
	async getNotificationsByCountry({ page, token, pharmacy }) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${ENVIROMENT.NOTIFICATION_V2}/notification/country/page/${page}`,
			params: { pharmacy: pharmacy },
			headers: { Authorization: `Bearer ${token}` },
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
}
